import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e3a9f088&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e3a9f088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a9f088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3a9f088')) {
      api.createRecord('e3a9f088', component.options)
    } else {
      api.reload('e3a9f088', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e3a9f088&scoped=true&", function () {
      api.rerender('e3a9f088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customPic/index.vue"
export default component.exports